import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled, { keyframes } from "styled-components";
import { Trans } from "@lingui/macro";
import { NAME_WEBSITE, URL_ICP, URL_ICP_NAME } from "sketon/const";
import { SCREEN_SM } from "sketon/ui/theme";

const StyledWapper = styled.div`
  width: 100%;
  padding-top: 0.2rem;
  padding-bottom: 20px;
  background-color: rgba(17, 17, 17, 0);
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  @media (min-width: ${SCREEN_SM}) {
    position: absolute;
    bottom: 0;
    padding-top: 50px;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  @media (max-width: ${SCREEN_SM}) {
    flex-flow: column;
  }
`;

const StyledCpDiv = styled.div`
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  font-size: 16px;
  line-height: 20px;
  text-align: left;
  font-weight: normal;
  color: rgba(17, 17, 17, 0.6);

  @media (max-width: ${SCREEN_SM}) {
    font-size: 0.2rem;
    line-height: 0%.22rem;
  }
`;

const StyledLink = styled.a`
  margin-top: 0;
  margin-left: 20px;
  padding: 0 0 0 0;
  border-radius: 0;

  font-size: 16px;
  line-height: 20px;
  text-align: left;
  font-weight: normal;
  text-decoration: none;
  color: rgba(17, 17, 17, 0.6);
  @media (max-width: ${SCREEN_SM}) {
    font-size: 0.2rem;
    line-height: 0.22rem;
    margin-left: 0;
  }
`;

export interface FooterProps {
  cp?: string;
  url?: string;
  urlText?: string;
}

const Footer: React.FC<FooterProps> = ({
  cp = NAME_WEBSITE,
  url = URL_ICP,
  urlText = URL_ICP_NAME,
}) => {
  return (
    <StyledWapper>
      <StyledContainer>
        <StyledCpDiv>{cp}</StyledCpDiv>
        <StyledLink href={url}>{urlText}</StyledLink>
      </StyledContainer>
    </StyledWapper>
  );
};

export default Footer;
